    import GlobalVariable from '@/global/global-variable'

    /* 获取公钥 */
    // const Get_PublicKey_Uri = GlobalVariable.OAM_PATH + "/getPublicKey";
    const Get_PublicKey_Uri = GlobalVariable.OAM_PATH + "/system/param/getPublicKey";

    /* 登录 */
    // const Login_Uri = GlobalVariable.OAM_PATH + "/login";
    const Login_Uri = GlobalVariable.OAM_PATH + "/toLogin";
    /* 授权 */
    const Is_Auth_Uri = GlobalVariable.OAM_PATH + "/oam/isAuth";
    const Save_Auth_Code_Uri = GlobalVariable.OAM_PATH + "/oam/saveAuth";
    const Find_Auth_Uri = GlobalVariable.OAM_PATH + "/oam/findAuth";

    /* Uwb标签 */
    const Search_Uwb_Tag_Uri = GlobalVariable.OAM_PATH + "/oam/searchUwbTag";
    const Find_Uwb_Tag_By_Binding_Type_Uri = GlobalVariable.OAM_PATH + "/oam/findUwbTagByBindingType";
    const Find_Uwb_UnAdd_Tag_Uri = GlobalVariable.OAM_PATH + "/oam/findUwbUnAddTag";
    const Add_Uwb_Tag_Id_Batch_Uri = GlobalVariable.OAM_PATH + "/oam/addUwbTagIdBatch";
    const Add_Uwb_Tag_Id_Uri = GlobalVariable.OAM_PATH + "/oam/addUwbTagId";
    const Add_Uwb_Tag_Uri = GlobalVariable.OAM_PATH + "/oam/addUwbTag";
    const Delete_Uwb_Tag_Uri = GlobalVariable.OAM_PATH + "/oam/deleteUwbTag";
    const Completely_Delete_Uwb_Tag_Uri = GlobalVariable.OAM_PATH + "/oam/completelyDeleteUwbTag";
    const Find_Uwb_Tag_By_TagId_Uri = GlobalVariable.OAM_PATH + "/oam/findUwbTagByTagId";

    /* GNSS标签 */
    const Search_GNSS_Tag_Uri = GlobalVariable.OAM_PATH + "/oam/searchGpsTag";
    const Find_GNSS_Tag_By_Binding_Type_Uri = GlobalVariable.OAM_PATH + "/oam/findGpsTagByBindingType";
    const Find_GNSS_UnAdd_Tag_Uri = GlobalVariable.OAM_PATH + "/oam/findGpsUnAddTag";
    const Delete_GNSS_Tag_Uri = GlobalVariable.OAM_PATH + "/oam/deleteGpsTag";

    /* Uwb基站 */
    const Search_Uwb_Bs_Uri = GlobalVariable.OAM_PATH + "/oam/searchUwbBs";
    const Find_Uwb_UnAdd_Bs_Uri = GlobalVariable.OAM_PATH + "/oam/findUwbUnAddBs";
    const Find_Uwb_Bs_By_ProjectId_Uri = GlobalVariable.OAM_PATH + "/oam/findUwbBsByProjectId";
    const Add_Uwb_Bs_Uri = GlobalVariable.OAM_PATH + "/oam/addUwbBs";
    const Update_Uwb_Bs_Point_Uri = GlobalVariable.OAM_PATH + "/oam/updateUwbBsPoint";
    const Delete_Uwb_Bs_Uri = GlobalVariable.OAM_PATH + "/oam/deleteUwbBs";
    const Completely_Delete_Uwb_Bs_Uri = GlobalVariable.OAM_PATH + "/oam/completelyDeleteUwbBs";

    /* Uwb测距基站 */
    const Search_Uwb_Range_Bs_Uri = GlobalVariable.OAM_PATH + "/oam/searchUwbRangeBs";
    const Find_Uwb_Range_Bs_By_GroupId_Uri = GlobalVariable.OAM_PATH + "/oam/findRangeBsByGroupId";
    const Add_Uwb_Range_Bs_Uri = GlobalVariable.OAM_PATH + "/oam/addUwbRangeBs";
    const Insert_Uwb_Range_Bs_Uri = GlobalVariable.OAM_PATH + "/oam/insertUwbRangeBs";
    const Update_Uwb_Range_Bs_Sort_Uri = GlobalVariable.OAM_PATH + "/oam/updateUwbRangeBsSort";
    const Update_Uwb_Range_Bs_Error_Uri = GlobalVariable.OAM_PATH + "/oam/updateUwbRangeBsError";
    const Update_Uwb_Range_Num_Uri = GlobalVariable.OAM_PATH + "/oam/updateUwbRangeNum";
    const Update_Uwb_Range_Error_Uri = GlobalVariable.OAM_PATH + "/oam/updateUwbRangeError";
    const Start_Uwb_Range_Uri = GlobalVariable.OAM_PATH + "/oam/startRange";
    const End_Uwb_Range_Uri = GlobalVariable.OAM_PATH + "/oam/endRange";
    const Delete_Uwb_Range_Group_Uri = GlobalVariable.OAM_PATH + "/oam/deleteUwbRangeGroup";
    const Delete_Uwb_Range_Bs_Uri = GlobalVariable.OAM_PATH + "/oam/deleteUwbRangeBs";

    /* Uwb 基站组 */
    const Search_Uwb_Bs_Group_Uri = GlobalVariable.OAM_PATH + "/oam/searchUwbBsGroup";

    /* 报警 */
    const Search_Alarm_Uri = GlobalVariable.OAM_PATH + "/rest/alarm/search";
    const Deal_Alarm_Uri = GlobalVariable.OAM_PATH + "/rest/alarm/dealAlarm";

    /* 轨迹 */
    const Search_Track_Uri = GlobalVariable.OAM_PATH + "/oam/searchTrack";

    /* 资源 */
    const Search_Role_Resources_Uri = GlobalVariable.OAM_PATH + "/rest/resource/search";
    const Search_All_Resources_Uri = GlobalVariable.OAM_PATH + "/rest/resource/searchAll";

    /* 角色 */
    const Search_Role_Uri = GlobalVariable.OAM_PATH + "/rest/role/search";
    const Add_Role_Uri = GlobalVariable.OAM_PATH + "/rest/role/add";
    const Update_Role_Uri = GlobalVariable.OAM_PATH + "/rest/role/update";
    const Delete_Role_Uri = GlobalVariable.OAM_PATH + "/rest/role/delete";

    /* 账户 */
    const Search_Account_Uri = GlobalVariable.OAM_PATH + "/rest/account/search";
    const Add_Account_Uri = GlobalVariable.OAM_PATH + "/rest/account/add";
    const Delete_Account_Uri = GlobalVariable.OAM_PATH + "/rest/account/delete";
    const Find_Account_By_Account_Uri = GlobalVariable.OAM_PATH + "/rest/account/search";
    const Find_Account_By_Id_Uri = GlobalVariable.OAM_PATH + "/rest/account/findByAccountId";

    /* 密码 */
    const Update_Pwd_Uri = GlobalVariable.OAM_PATH + "/rest/account/updatePwd";
    const Rest_Pwd_Uri = GlobalVariable.OAM_PATH + "/rest/account/restPwd";

    /* 查询项目结构 */
    const Find_Org_Uri = GlobalVariable.OAM_PATH + "/rest/app/findOrg";

    const Update_Project_Uri = GlobalVariable.OAM_PATH + "/oam/updateProject";

    /* 区域 */
    const Add_Area_Uri = GlobalVariable.OAM_PATH + "/oam/addArea";
    const Update_Area_Uri = GlobalVariable.OAM_PATH + "/oam/updateArea";
    const Delete_Area_Uri = GlobalVariable.OAM_PATH + "/oam/deleteArea";
    const Find_Area_By_Id_Uri = GlobalVariable.OAM_PATH + "/oam/findAreaById";


    /* 地图 */
    const Add_Map_Uri = GlobalVariable.OAM_PATH + "/oam/addMap";
    const Update_Map_Uri = GlobalVariable.OAM_PATH + "/oam/updateMap";
    const Delete_Map_Uri = GlobalVariable.OAM_PATH + "/oam/deleteMap";
    const Find_Map_By_ProjectId_Uri = GlobalVariable.OAM_PATH + "/oam/findMapByProjectId";
    const Find_Map_By_Id_Uri = GlobalVariable.OAM_PATH + "/oam/findMapById";
    const Upload_Map_Uri = GlobalVariable.OAM_PATH + "/oam/uploadMap";


    /* 获取NVR信息 */
    const Get_NVR_Uri = GlobalVariable.OAM_PATH + "/oam/getNVRInfos"
    // 保存录制视频
    const Save_Video_Uri = GlobalVariable.OAM_PATH + "/oam/saveVideo"
    // 查找视频地址
    const Find_Video_Uri = GlobalVariable.OAM_PATH + "/oam/findVideo"

    // 查找NVR地址
    const Search_NVR_Uri = GlobalVariable.OAM_PATH + "/oam/searchNVR"


    /* 语音 */
    const Text_To_Voice_Uri = GlobalVariable.OAM_PATH + "/oam/textToVoice";

    export default {
        Get_PublicKey_Uri,
        Login_Uri,
		
		/* 授权 */
		Is_Auth_Uri,
		Save_Auth_Code_Uri,
		Find_Auth_Uri,
		
        /* Uwb标签 */
        Search_Uwb_Tag_Uri,
        Find_Uwb_Tag_By_Binding_Type_Uri,
        Find_Uwb_UnAdd_Tag_Uri,
        Add_Uwb_Tag_Id_Batch_Uri,
        Add_Uwb_Tag_Id_Uri,
        Add_Uwb_Tag_Uri,
        Delete_Uwb_Tag_Uri,
        Completely_Delete_Uwb_Tag_Uri,
        Find_Uwb_Tag_By_TagId_Uri,

        /* GNSS标签 */
        Search_GNSS_Tag_Uri,
        Find_GNSS_Tag_By_Binding_Type_Uri,
        Find_GNSS_UnAdd_Tag_Uri,
        Delete_GNSS_Tag_Uri,


        /* Uwb基站 */
        Search_Uwb_Bs_Uri,
        Find_Uwb_UnAdd_Bs_Uri,
        Find_Uwb_Bs_By_ProjectId_Uri,
        Add_Uwb_Bs_Uri,
        Update_Uwb_Bs_Point_Uri,
        Delete_Uwb_Bs_Uri,
        Completely_Delete_Uwb_Bs_Uri,

        /* Uwb基站组 */
        Search_Uwb_Bs_Group_Uri,

        /* Uwb测距基站 */
        Search_Uwb_Range_Bs_Uri,
        Find_Uwb_Range_Bs_By_GroupId_Uri,
        Add_Uwb_Range_Bs_Uri,
        Insert_Uwb_Range_Bs_Uri,
        Update_Uwb_Range_Bs_Sort_Uri,
        Update_Uwb_Range_Bs_Error_Uri,
        Update_Uwb_Range_Num_Uri,
        Update_Uwb_Range_Error_Uri,
        Start_Uwb_Range_Uri,
        End_Uwb_Range_Uri,
        Delete_Uwb_Range_Group_Uri,
        Delete_Uwb_Range_Bs_Uri,

        /* 报警 */
        Search_Alarm_Uri,
        Deal_Alarm_Uri,

        /* 轨迹 */
        Search_Track_Uri,

        /* 资源 */
        Search_Role_Resources_Uri,
        Search_All_Resources_Uri,

        /* 角色 */
        Search_Role_Uri,
        Add_Role_Uri,
        Update_Role_Uri,
        Delete_Role_Uri,

        /* 账户 */
        Search_Account_Uri,
        Add_Account_Uri,
        Delete_Account_Uri,
        Find_Account_By_Account_Uri,
        Find_Account_By_Id_Uri,

        /* 密码 */
        Update_Pwd_Uri,
        Rest_Pwd_Uri,

        /* 查询项目结构 */
        Find_Org_Uri,
        Update_Project_Uri,

        /* 区域 */
        Add_Area_Uri,
        Update_Area_Uri,
        Delete_Area_Uri,
        Find_Area_By_Id_Uri,

        /* 地图 */
        Add_Map_Uri,
        Update_Map_Uri ,
        Delete_Map_Uri ,
        Find_Map_By_ProjectId_Uri,
        Find_Map_By_Id_Uri,
        Upload_Map_Uri,

        Get_NVR_Uri,
        Save_Video_Uri,
        Find_Video_Uri,
        Search_NVR_Uri,

        /* 语音 */
        Text_To_Voice_Uri ,

    }


// WEBPACK FOOTER //
// ./src/request/api-oam.js